var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrayLeaf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4972 1.80957C8.48069 1.30486 8.12575 0.896077 7.63049 0.820995C5.92182 0.549867 4.06458 1.05458 2.61593 2.34766C1.16728 3.64073 0.449145 5.44269 0.502799 7.19043C0.519308 7.69514 0.874248 8.10392 1.36951 8.179C3.07818 8.45013 4.93542 7.94542 6.38407 6.65234C7.83272 5.35927 8.55085 3.55731 8.4972 1.80957Z",
    fill: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayLeaf);
export default __webpack_public_path__ + "static/media/grayLeaf.dc819a5e772b70cb1ac14325ef3fb614.svg";
export { ForwardRef as ReactComponent };